import React, { useEffect } from "react";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
import { ROUTE } from "../../route/Route";
import SeoAdd from "../Seo/SeoAdd";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <SeoAdd slug={ROUTE.PRIVACY} />
      <div className="content pb-0 pt-0 bg-gray">
        <BreadCrumb page={t("privacy_policy")} data={{ slug: "", path: "" }} />
        <section className="about-section">
          <div className="container" id="section2">
            <div className="row">
              <div className="col-md-12">
                <div className="overview-wrap">
                  <div className="headingmains text-center pb-4">
                    <h1 className="right">{t("privacy_policy")}</h1>
                  </div>
                  {/* <ul className='policy'>
                                <li>{t("privacy_policy_info1")}</li>
                                <li>{t("privacy_policy_info2")}</li>
                                <li>{t("privacy_policy_info3")}</li>
                                </ul> */}
                  <div className="about-new-content">
                    <div className="container">
                      <p>
                        This Privacy Policy governs how we,
                        “Oncquest” ,“Company”, “we”, “us” or&quot; our” collect,
                        use, share and process your information, that you
                        provide to us on our Website
                        <a
                          href="https://oncquestlabs.com"
                          className="text-info"
                          target="_blank"
                        >
                          {" "}
                          oncquestlabs
                        </a>{" "}
                        in the course of providing services(“Services”) as
                        defined in the Terms and Conditions{" "}
                        <a
                          href="https://oncquestlabs.com/privacy-policy"
                          className="text-info"
                          target="_blank"
                        >
                          privacy-policy
                        </a>{" "}
                        to you.
                      </p>

                      <p>
                        Oncquest Laboratories Limited respects your privacy and
                        seeks to comply with all the applicable legal
                        requirements in respect of data collection, processing
                        and transfer.
                      </p>

                      <p>
                        Please read this Privacy Policy carefully. By accessing
                        or using this website, you agree to be bound by the
                        terms described herein and all the terms incorporated by
                        reference. If you do not agree to all of these terms, do
                        not use this website.
                      </p>

                      <h3>1.What is Personal Information?</h3>
                      <p>
                        Personal information is that information which can be
                        used to directly or indirectly identify you. It includes
                        de-identified data that, when linked to other
                        information available to us, would enable us to identify
                        you. Personal data does not include data that has been
                        irreversibly anonymized or aggregated so that we cannot
                        identify you through it, even in conjugation conjunction
                        with other information.
                      </p>

                      <p>
                        “Sensitive Personal Data or Information” means Personal
                        Information of any individual relating to password
                        financial information such as bank account or credit
                        card or debit card or other payment instrument details
                        physical, physiological and mental health condition
                        sexual orientation medical records and history biometric
                        information any detail relating to the above as provided
                        to or received by Oncquest Laboratories Limited for
                        processing or storage. However, any data/ information
                        relating to an individual that is freely available or
                        accessible in public domain or furnished under the Right
                        to Information Act, 2005 or any other law shall not
                        qualify as Sensitive Personal Data or Information.
                      </p>

                      <p>
                        By clicking &quot;I accept&quot; when proceeding to the
                        Website, and/or using our services you represent that
                        you voluntarily provide us with personal information
                        including medical and financial information and consent
                        to their collection, use and disclosure in accordance
                        with this Privacy Policy. You also represent that you
                        are duly authorised by any third party (including a
                        child or an employer) whose information you share with
                        us. We shall act as per your representation of authority
                        and shall not make any independent enquiries to
                        ascertain the veracity of your authorisation. In the
                        event you do not have sufficient authorisation you shall
                        be solely responsible for your acts and omissions
                        including sharing of information with us by you and the
                        consequential processing and actions taken by us in
                        accordance with this Privacy Policy.
                      </p>

                      <h3>2.What types of data do we collect?</h3>
                      <p>
                        Oncquest, like many other websites uses “Cookies”.
                        Cookies are small data files that a website stores on
                        your web browser. These are used for the purpose of
                        storing your preferences, previous activities browsing
                        activities, profiling and tracking behaviour on this
                        Website. By visiting Oncquest website, you acknowledge,
                        accept and expressly authorize the placement of cookies
                        on your web browser. We recommend that you clear the
                        cookies stored on your browser from time to time.
                      </p>
                      <p>
                        When you sign up or register on the Oncquest
                        Laboratories Limited Website to use our Services, and
                        during the course of actual usage of our Services, the
                        types of information that will be collected by us
                        include the following:
                      </p>
                      <ul className="policy align-items-start">
                        <li>
                          Contact information: Name, Address, Contact details,
                          Email ID, Phone Number
                        </li>
                        <li>
                          Demographic information: Gender, Age, Date of Birth
                          Marital Status, Nationality
                        </li>
                        <li>
                          Data regarding your usage of the services such as
                          search history and history of the appointments made by
                          you through the use of Services
                        </li>
                        <li>
                          Any other detail relating to the above as voluntarily
                          provided to Oncquest Laboratories Limited by you, for
                          providing value added service
                        </li>
                        <li>
                          Medical records and history which you voluntarily
                          provide or is generated on usage of any of the
                          services availed by you from Oncquest
                        </li>
                        <li>
                          Physical, physiological and mental health condition
                          which you voluntarily provide or is generated on usage
                          of our services through the website
                        </li>
                        <li>
                          Data regarding your medical qualifications,
                          registrations and certifications
                        </li>
                        <li>
                          Any additional information that you voluntarily choose
                          to provide to Oncquest Laboratories Limited through
                          any mode of communication or during any interaction.
                        </li>
                      </ul>

                      <h3>3.Where do we collect your data from?</h3>
                      <p>For end users:</p>
                      <p>
                        Any information that you voluntarily choose to provide
                        to us through , website, email, during interaction with
                        us on call or chat and other modes of communication
                      </p>
                      <p>
                        Information that we collect from healthcare service
                        providers (HSPs) such as doctors, hospitals, diagnostic
                        centres, chemists etc. in the Oncquest, to whom you have
                        permitted the sharing of your personal information
                      </p>
                      <p>
                        Data you have provided to any group company of the
                        Company, affiliates, associates, subsidiary, holding
                        company of the Company, associates and subsidiaries of
                        holding company of the Company, to whom you have given
                        consent for sharing of such information. For doctors:
                      </p>
                      <p>
                        Before onboarding you, we may request information
                        regarding your qualifications, experience, public
                        profile, and representations made by you to us During
                        your usage of the Website, we may collect information
                        based on your use of the Services
                      </p>
                      <p>
                        We may collect other information that you voluntarily
                        choose to provide to us through website, email, during
                        interaction with us on call or chat and other modes of
                        communication We may collect information from any group
                        company, affiliates, associates, subsidiary, holding
                        company of the Company, associates and subsidiaries of
                        holding company of the Company to whom you have given
                        consent for sharing of information for availing value
                        added service
                      </p>

                      <h3>4.How do we use your data?</h3>
                      <p>
                        We use your Personal Information for purposes that
                        include the following:
                      </p>

                      <h5>General (end users and doctors):</h5>
                      <ul className="policy align-items-start">
                        <li>
                          Your registration for the purpose of receiving our
                          Services, identification, communication, notification
                          and for fulfilment of the Terms and Conditions on the
                          website Analysis, research, training and disclosure
                          (where required) to its affiliates, agents and
                          government authorities.
                        </li>
                        <li>
                          Offering you personalised Services and marketing,
                          promotional and other targeted advertisement of
                          various healthcare and wellness plans, customised
                          health insights by way of RCS/SMS messages, email
                          communication or other recognised and accepted mode of
                          communication.
                        </li>
                        <li>Improvement of our products and services</li>
                        <li>
                          Research and analysis for the development of
                          commercial solutions
                        </li>
                        <li>
                          Addressing your requests, queries and complaints, in
                          any, pertaining to our Services
                        </li>
                        <li>other customer care related activities</li>
                        <li>
                          Investigating, enforcing, and resolving disputes
                        </li>
                        <li>
                          For the purpose of contacting, you to provide you with
                          information on new Services and offers, taking
                          feedback, assisting you with completion of
                          transactions or other issues relating to the use of
                          Services
                        </li>
                        <li>
                          To send notices, communications, alerts, new offers
                          relevant to use of the Services offered by Oncquest
                          Laboratories Limited on Website
                        </li>
                        <li>
                          Carrying out our obligations in relation to any
                          agreement with our business partners or contractors
                        </li>
                        <li>
                          Technical administration and customization of Website,
                          and other general administrative and business purposes
                        </li>
                        <li>
                          To send you information about special promotions or
                          offers (either offered by Oncquest Laboratories
                          Limited or by its business partners), new features or
                          products both of the Oncquest as well as third-party
                          offers or products with whom Oncquest Laboratories
                          Limited has a tie-up
                        </li>
                      </ul>

                      <h5>For end users only:</h5>
                      <ul className="policy align-items-start">
                        <li>
                          Creation and maintenance of health records in
                          electronic form in the Personal Health Record (PHR)
                          database
                        </li>
                        <li>
                          For sharing with your chosen HSP in Oncquest like
                          doctors, hospitals, diagnostic centres, chemists who
                          may provide you services under the Oncquest
                          Laboratories Limited Platform. Processing any orders
                          you may place using our Services For doctors only
                        </li>
                        <li>
                          For verifying your professional credentials and any
                          representations you have made to us
                        </li>
                        <li>For processing any payments made to you</li>
                        <li>
                          For providing recommendations to end users based on
                          your expertise and specialisations
                        </li>
                        <li>For providing any other service to you.</li>
                      </ul>

                      <h3>5.How long will we retain your data?</h3>
                      <p>
                        We store your personal information in accordance with
                        applicable laws, which means we keep your data for as
                        long as necessary to provide you with our Services or as
                        may be required under any law. We shall store your
                        personal information for lawful purposes only. We keep
                        de-identified data for research and statistical purposes
                        for a longer period.
                      </p>
                      <p>
                        If you close your account, we have no obligation to
                        retain your data, and we may delete any or all of your
                        data without liability. However, we may retain data
                        related to you if we believe it may be necessary to
                        prevent fraud or future abuse, or if required by law, or
                        for other legitimate purposes. We may continue to store
                        your data in anonymised form for analytical and research
                        purposes.
                      </p>

                      <h3>6.Disclosure and transfer of your data</h3>
                      <p>
                        We may disclose and, in some cases, transfer your
                        personal information to such entities as required to
                        provide services to you and to provide value added
                        services or other third party products and services, to
                        the extent permitted by applicable law. These entities
                        may be located outside India, which you hereby consent
                        to. We require such entities to protect your information
                        through equivalent security measures as what we would
                        adopt. An indicative list of entities we may disclose or
                        transfer information to, are provided below:
                      </p>
                      <p>
                        Service Providers: We share personal information with
                        companies that provide Services on our behalf, such as
                        website hosting, data storage, software services, email
                        services, marketing, fulfilling customer orders,
                        providing payment services, data analytics, data mining,
                        providing customer services, and conducting surveys.
                        These companies may be located within or outside India,
                        but in any case, are obligated to protect your data. We
                        may also share information with employees, data
                        processors, consultants, business partners and
                        technology partners on a need to know basis. Such
                        entities would be contractually obligated to maintain
                        confidentiality in relation to your data.
                      </p>
                      <p>
                        If you are an end user, your personal information will
                        also be shared with your chosen HSPs. Business
                        Affiliates: We may disclose or transfer some of your
                        information to entities in Oncquest, affiliates,
                        associates, subsidiary, holding company of the Company,
                        associates and subsidiary of holding company of the
                        Company including foreign entities, and in particular
                        group companies and affiliates who are involved in the
                        provision of products and services, to the extent
                        permitted by applicable law.
                      </p>
                      <p>
                        In the event of a merger, reorganization, acquisition,
                        joint venture, assignment, spin-off, transfer, asset
                        sale, or sale or disposition of all or any portion of
                        our business, including in connection with any
                        bankruptcy or similar proceedings, we may transfer any
                        and all personal information to the relevant third party
                        with the same rights of access and use.
                      </p>
                      <p>
                        Law Enforcement Agencies: We may share information with
                        law enforcement agencies pursuant to lawful requests for
                        information, and otherwise as required under any law
                        applicable at the given time, both in India and outside
                        India.
                      </p>
                      <p>Other Third Parties:</p>
                      <p>
                        We may also disclose personal information if we
                        determine in good faith that disclosure is reasonably
                        necessary to protect our rights and pursue available
                        remedies, enforce our terms and conditions, investigate
                        fraud, or protect our operations or users.
                      </p>
                      <p>
                        Anonymised, aggregated data that cannot re-identify you,
                        may be shared with advertisers, research firms and other
                        partners.
                      </p>

                      <h3>7.How do we protect your data?</h3>
                      <p>
                        We are committed towards maintaining the privacy of the
                        information uploaded by you on the website and complies
                        with the industry standard security safeguards for the
                        purpose of securing the website and the information
                        provided/uploaded by you.
                      </p>
                      <p>
                        We use reasonable technical, administrative, and
                        physical security measures for the purpose of
                        safeguarding all data you share with us. We also have
                        comprehensive internal policies in place to prevent
                        unauthorized access to your data. We take adequate steps
                        to ensure that third parties we share data with also
                        adopt reasonable level of security practices and
                        procedures to ensure the privacy and security of your
                        information.
                      </p>
                      <p>
                        However, we are not responsible for any loss,
                        unauthorised access, safety issue or any harm caused to
                        you by any misuse of your personal information, unless
                        it is a direct and foreseeable consequence of negligence
                        and non-compliance on our part only. You hereby
                        acknowledge that we are not responsible, in particular,
                        for any third party action or action on your part
                        leading to loss, damage or harm to you or any other
                        person.
                      </p>
                      <p>
                        For any data loss or theft due to unauthorized access to
                        your electronic devices through which you avail our
                        Services, Company shall not be held liable for any loss
                        whatsoever incurred by you. Further, you are liable to
                        indemnify the Company as per the Terms of Use.
                      </p>

                      <h3>8.What are your rights?</h3>
                      <p>
                        We take reasonable steps to ensure that your personal
                        information is accurate, complete, and up to date.
                        However, you have the sole responsibility of ensuring
                        that you review the accuracy of information provided by
                        you and contact us in case of discrepancies, or in case
                        you wish to discontinue the use of our services. You
                        have the following rights with regard to your personal
                        information:
                      </p>
                      <p>
                        You have the right to access your personal information,
                        and request correction and deletion. If your personal
                        information changes, you may correct, delete
                        inaccuracies, or amend information by making the change
                        on our member information page. We will make good faith
                        efforts to make requested changes in our then active
                        databases as soon as reasonably practicable. If you
                        provide any information that is untrue, inaccurate, out
                        of date or incomplete (or subsequently becomes untrue,
                        inaccurate, out of date or incomplete), or we have
                        reasonable grounds to suspect that the information
                        provided by you is untrue, inaccurate, out of date or
                        incomplete, we may, at our sole discretion, discontinue
                        the provision of the Services to you. There may be
                        circumstances where we will not correct, delete or
                        update your Personal Information, including (a) where
                        the Personal Information is opinion data that is kept
                        solely for evaluative purpose and (b) the Personal
                        Information is in documents related to a prosecution if
                        all proceedings relating to the prosecution have not
                        been completed.
                      </p>
                      <p>
                        You are free to not to share any medical or other
                        information that you consider confidential and withdraw
                        consent for us to use data that you have already
                        provided. In the event that you refuse to share any
                        information or withdraw consent to process information
                        that you have previously given to us, we reserve the
                        right to restrict or deny the provision of our services
                        for which we consider such information to be necessary.
                      </p>
                      <p>
                        You may contact Grievance Cell for any questions or for
                        exercise of these rights.
                      </p>
                      <p>
                        Email:{" "}
                        <a href="mailto:grievance.cell@oncquest.net">
                          grievance.cell@oncquest.net
                        </a>{" "}
                      </p>
                      <p>
                        We will respond to your request within a reasonable
                        time.
                      </p>

                      <h3>9.Third Party Websites and Services</h3>
                      <p>
                        Our Website and may contain links to third party
                        services and give you the ability to access such
                        third-party websites, products, and services. Please
                        note that you may proceed to the use of such third party
                        website or service at your own risk and the Company will
                        not be held liable for any outcome or harm arising as a
                        result of your use of such third party websites or
                        services. Please read the privacy policies of any third
                        party before proceeding to use their websites, products,
                        or services.
                      </p>

                      <h3>10.Changes to this Privacy Policy</h3>
                      <p>
                        We may periodically revise or update this Privacy
                        Policy. Your continued use of our products and services
                        after the effective date of the Privacy Policy means
                        that you accept the revised Privacy Policy. If you do
                        not agree with any such revised terms, please refrain
                        from using our Services and contact us to close any
                        account you may have created.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
